import { StyledShadow } from './ShopShadow.styled';

const ShopShadow = () => {
	return (
		<div>
			<StyledShadow style={{ left: -1000, top: -1000 }} />
			<StyledShadow style={{ right: -1000, top: -1000 }} />
			<StyledShadow style={{ left: -1000, bottom: -1000 }} />
			<StyledShadow style={{ right: -1000, bottom: -1000 }} />
		</div>
	);
};

export { ShopShadow };
